require("!!/Users/s.kressmann/Sites/PerformanceTrust/FutureShapeAngular/trunk/node_modules/script-loader/addScript.js")(require("!!/Users/s.kressmann/Sites/PerformanceTrust/FutureShapeAngular/trunk/node_modules/raw-loader/index.js!/Users/s.kressmann/Sites/PerformanceTrust/FutureShapeAngular/trunk/node_modules/chart.js/dist/Chart.bundle.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.bundle.min.js
// module id = 715
// module chunks = 7